import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {Router, NavigationStart, NavigationEnd, RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {routing}             from './app.routing';
import {AppComponent}        from './app.component';
import {PagesModule}         from '../app/pages/pages.module';
import {StructureModule}     from './structure/structure.module';


import {TopBarComponent}       from './components/top-bar/top-bar.component';
import {MenuLeftComponent}     from './components/menu-left/menu-left.component';
import {FooterComponent}       from './components/footer/footer.component';

import {ApiConstant}           from '../api/api.constant';
import {RegisterService}       from '../api/register/register.service';
import {LoginService}          from '../api/login/login.service';


import {PortfolioService}    from '../api/portfolio/portfolio.service';
import {HiringRequestService} from "../api/hiringrequest/hiringrequest.service";
import {ClientService} from "../api/client/client.service";
import {SiteconfigService} from "../api/siteconfig/siteconfig.service";
import {ContactUSService} from "../api/contactus/contactus.service";
import {HiringService} from "../api/hiring/hiring.service";
import {HttpManagerService} from "../api/httpmanager.service";
import {BlogService} from "../api/blog/blog.service";
import {NewprojectService} from "../api/newproject/newproject.service";
import {TraineeService} from "../api/trainee/trainee.service";
import {BlogcategoryService} from "../api/blogcategory/blogcategory.service";
import {CapitalizePipeComponent} from "./capitalize-pipe/capitalize-pipe.component";

import { BloguserService } from 'api/bloguser/bloguser.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogtagService } from 'api/blogtag/blogtag.service';



import { AdmincrashreportService } from 'api/admincrashreport/admincrashreport.service';


declare var NProgress: any;

@NgModule({
    declarations: [
        AppComponent,
        TopBarComponent,
        MenuLeftComponent,
        FooterComponent,
        CapitalizePipeComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        RouterModule,
        PagesModule,
        NgbModule.forRoot(),
        StructureModule,
        routing,
      
       
       
           
    ],
    providers: [ApiConstant, RegisterService, LoginService,HttpManagerService,
        PortfolioService,
        BlogService,
        HiringService,
        HiringRequestService,
        BlogcategoryService,
        ClientService,
        ContactUSService,
        SiteconfigService,
        BlogService,
        BloguserService,
        BlogpostService,
        BlogPostdetailsService,
        BlogtagService,
        NewprojectService,
        TraineeService,
        AdmincrashreportService
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
    constructor(private router: Router) {
        router.events.subscribe((event) => {

            if (event instanceof NavigationStart) {
                NProgress.start();
            }

            if (event instanceof NavigationEnd) {
                setTimeout(function () {
                    NProgress.done();
                }, 200);
            }

        });
    }
}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/app.module.ts